import { AxiosResponse } from 'axios';
import api from '~/utils/api';

export async function init(): Promise<AxiosResponse<any>> {
  return api.post('/init_logged');
}
